<template>
  <div class="cell-container" @click="clickCell(message)">
    <div>
      <img :src="getUrl(message.Image)" />
    </div>
    <div class="date">
      {{ dateFormat("YYYY-mm-dd", new Date(message.PublishTime)) }}
    </div>
    <div class="title">{{ message.Title }}</div>
    <div class="des">
      {{ message.Abstract }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["message"],
  created() {
    console.log(this.message, "fsafdsfdsa");
  },
  methods: {
    clickCell(message) {
      this.$router.push({
        path: "/detail",
        query: { dID: message.PublishMessageID }
      });
    },
    getUrl(url) {
      if (!url) {
        return require("@/assets/home/banner_index01.png");
      }
      return window.API_URL + url;
    },
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    }
  }
};
</script>
<style lang="less" scoped>
.cell-container {
  transition: all 0.6s;
  &:hover {
    box-shadow: 3px 3px 3px #eeeeee;
    transform: scale(1.01, 1.01);
    transition: all 0.6s;
  }
  height: 359px;
  width: 382px;
  position: relative;
  margin: 0 5px;
  background-color: #f7f9fb;
  img {
    height: 180px;
    // background-color: red;
    width: 100%;
  }
  .date {
    width: 114px;
    height: 36px;
    background-color: #fc8100;
    border-radius: 2px;
    color: #ffffff;
    line-height: 36px;
    text-align: center;
    position: absolute;
    top: 160px;
    left: 30px;
  }
  .title {
    font-size: 18px;
    color: #000000;
    padding: 20px 20px 0 20px;
  }
  .des {
    font-size: 14px;
    color: #666666;
    padding: 20px 20px 0 20px;
  }
}
</style>
